import React, { memo } from 'react';

/**
 * Unified Points Icon - Use this everywhere points are displayed
 * A premium filled star icon consistent across the entire app
 */
const PointsIcon = memo(({ size = 16, color = '#f59e0b', className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    stroke={color}
    strokeWidth="0"
    className={`points-icon ${className}`}
    style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
));

PointsIcon.displayName = 'PointsIcon';

export default PointsIcon;
